import routeMixin from '@/router/routeMixin'
import globalMixin from '../globalMixin'
import mixins from 'vue-typed-mixins'
import { CommandeEffectuee, CommandeEffectueeLight } from './models/Commande'
import Openable from '@/global/viewmodels/openable'
import { HubConnectionBuilder } from '@microsoft/signalr'
import mobileTypeMixin from '@/plugins/mixins/mobileTypeMixin'

export default mixins(routeMixin, globalMixin, mobileTypeMixin).extend({
    data() {
        return {
            commandesEffectuees: [] as Array<CommandeEffectueeLight>,
            commandeEffectuee: null as CommandeEffectuee | null,
            openableCommandeInfo: new Openable()
        }
    },
    mounted() {
        this.initialize()
    },
    methods: {
        initialize() {
            this.loadAllCommandesEffectuees()
            const connection = new HubConnectionBuilder().withUrl(process.env.VUE_APP_API_URL + '/hubs/refresh').build()
            connection.start().then(() => {
                connection.on('RefreshCommandesEffectuees', () => {
                    this.loadAllCommandesEffectuees()
                })
            })
        },
        loadAllCommandesEffectuees() {
            this.$http
                .api(`commande/resultats`)
                .get()
                .then(x => {
                    this.commandesEffectuees = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        loadCommandeDetaillee(id: number) {
            this.$http
                .api(`commande/resultat?id=${id}`)
                .get()
                .then(x => {
                    this.commandeEffectuee = x.data
                    this.openableCommandeInfo.open()
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        }
    }
})
